export interface IStarWithPartialFill {
  baseColor?: string;
  fillColor?: string;
  fillPercentage: number;
  strokeColor?: string;
  strokeWidth?: number;
}
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { imgMaxHeight: number | null }>(
  {
    root: {
      margin: 'auto',
    },
  },
  {
    name: 'star-with-partial-fill',
  },
);

export default useStyles;
